var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as MuiButton } from '@mui/material';
import Text from '../Text';
import React from 'react';
import ButtonOverlay from './Button.Overlay';
import getTextColor from './getTextColor';
function Button(props, ref) {
    var _a;
    var overrideColors = props.overrideColors, onClick = props.onClick, label = props.label, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? 'contained' : _c, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.submit, submit = _e === void 0 ? false : _e, _f = props.size, size = _f === void 0 ? 'small' : _f, startIcon = props.startIcon, endIcon = props.endIcon, _g = props.color, color = _g === void 0 ? 'primary' : _g, className = props.className, children = props.children;
    var textColor = getTextColor(props);
    var textVariant = size === 'small' ? 'body2Semibold' : 'body1Semibold';
    var style = { position: 'relative' };
    if (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
        style.background = overrideColors.backgroundColor;
    var customClasses = "".concat(className !== null && className !== void 0 ? className : '').concat(variant.startsWith('action-') ? 'action-button' : '');
    return (_jsxs(MuiButton, __assign({ ref: ref, sx: style, disableRipple: true, size: size, type: submit ? 'submit' : 'button', disableElevation: true, fullWidth: fullWidth, variant: variant, onClick: onClick, disabled: disabled, startIcon: startIcon, endIcon: endIcon, color: variant === 'text' ? 'primary' : color, className: customClasses }, { children: [(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor) && _jsx(ButtonOverlay, { br: size === 'small' ? 4 : 8 }), label && (_jsx(Text, __assign({ color: (_a = overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.textColor) !== null && _a !== void 0 ? _a : textColor, variant: textVariant }, { children: label }))), children] })));
}
// https://stackoverflow.com/a/58473012
var ButtonWithRef = React.forwardRef(Button);
export default ButtonWithRef;
